import { render, staticRenderFns } from "./SSOSignInForm.vue?vue&type=template&id=7bf9958a&scoped=true"
import script from "./SSOSignInForm.vue?vue&type=script&lang=ts"
export * from "./SSOSignInForm.vue?vue&type=script&lang=ts"
import style0 from "./SSOSignInForm.vue?vue&type=style&index=0&id=7bf9958a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf9958a",
  null
  
)

export default component.exports